module.exports = __webpack_public_path__ + "img/ewh-6.b0b5b2cf.png";